import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { addDisplayName } from "../Infra/display-name";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { useViewModel } from "./useViewModel";
import { SocialLoginCallbackViewModel } from "./SocialLoginCallbackViewModel";
export const SocialLoginCallbackView = observer((props) => {
    const model = useViewModel(SocialLoginCallbackViewModel, props.container);
    return _jsx(LoadingPlaceholder, { w: 10, h: 60 });
});
addDisplayName(SocialLoginCallbackView, "SocialLoginCallbackView");
